(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/set-self-exclusion-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/set-self-exclusion-abtest.js');
'use strict';

const {
  useAtom
} = jotai;
const {
  GamesAbTest,
  PeriodsAbTest,
  NativeApp
} = svs.selfExclusion.components;
const {
  ReactButton: Button
} = svs.ui;
const {
  Form
} = svs.ui.reactForm;
const {
  useState
} = React;
const {
  DOCS,
  isNativeApp
} = svs.selfExclusion.Constants;
const {
  DataService
} = svs.accountservices.player_exclusions;
const {
  activeExclusionsAtom,
  isNaExcludedAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const SetSelfExclusionAbTest = () => {
  const [game, setGame] = useState();
  const [period, setPeriod] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeExclusions, setActiveExclusions] = useAtom(activeExclusionsAtom);
  const [, setNaExcluded] = useAtom(isNaExcludedAtom);
  const exclusionDates = svs.selfExclusion.useExpiryDate(activeExclusions, game);
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitted(true);
    if (!game || !period) {
      return;
    }
    DataService.setSelfExclusion(game, period, setActiveExclusions, setNaExcluded);
    setIsSubmitted(false);
    setGame();
    setPeriod();
  };
  const handleGame = gameValue => {
    setGame(gameValue);
    setPeriod();
    setIsSubmitted(false);
  };
  const handlePeriod = periodValue => {
    setPeriod(periodValue);
    setIsSubmitted(false);
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2 padding-xs-bottom-2",
    id: "set-self-exclusions"
  }, React.createElement(Form, {
    "aria-live": "polite",
    onSubmit: handleSubmit
  }, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2",
    id: "self-exclusion-header"
  }, "Spelpaus i 3 m\xE5nader till 3 \xE5r"), React.createElement("p", {
    className: "exclusion-text-align"
  }, "Pausen g\xE4ller spel hos oss p\xE5 Svenska Spel Sport & Casino."), React.createElement(GamesAbTest, {
    game: game,
    isSubmitted: isSubmitted,
    onHandleGame: handleGame
  }), React.createElement(PeriodsAbTest, {
    exclusionDates: exclusionDates,
    exclusions: activeExclusions,
    isSubmitted: isSubmitted,
    onHandlePeriod: handlePeriod,
    period: period
  }), React.createElement("p", null, "Genom att aktivera en l\xE4ngre spelpaus godk\xE4nner du", ' ', isNativeApp ? React.createElement(NativeApp, null) : React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_INFORMATION,
    rel: "noreferrer",
    target: "_blank"
  }, "villkoren f\xF6r spelpaus"), ' ', "och bekr\xE4ftar att du tagit del av", ' ', React.createElement("a", {
    className: "fc-sport-75",
    href: DOCS.PERSONAL_POLICY,
    rel: "noreferrer",
    target: "_blank"
  }, "information om behandling av personuppgifter."), ' '), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    inverted: !!game && !!period,
    size: 300,
    transparent: !game || !period,
    type: "submit"
  }, "Aktivera paus")));
};
svs.selfExclusion.components.SetSelfExclusionAbTest = SetSelfExclusionAbTest;

 })(window);